const MajorPid = resolve =>require(['@/components/admin/MajorPid.vue'], resolve)

export default {
  path: '/appadmin/majorPid',
  name:'MajorPid',
  component: MajorPid,
}



// WEBPACK FOOTER //
// ./src/router/admin/major.js